const root = '/legacy/documents'

export const documentsRoutes = {
  main: root,
  reminders: `${root}/reminders`,
  settings: `${root}/settings`,
}

const legalAdvice = '/rechtsberatung'

export const legalAdviceRoutes = {
  main: legalAdvice,
  pastEvents: `${legalAdvice}/verlauf`,
  bookLawyer: `${legalAdvice}/beratungstermin`,
}

export const ROUTE_UPGRADE_SUBSCRIPTION = '/abo'

const templates = '/templates'

export const templatesRoutes = {
  main: templates,
  create: '/template/new',
}
